export default __webpack_public_path__ + "static/media/gate.6aa564ad.svg";